<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">

      <!--首页搜索-->
      <div class="nav_bar">
<!--        <button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>-->
        <p class="clear_style fl nav_bar_search tc">选择商品</p>
      </div>
      <div style="padding-top: 3rem;">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="clear_both" style="padding-bottom: 3rem;min-height: 45rem">
            <div class="ovh" v-if="!showDateView" style="padding: 0.5rem 0.5rem 0.5rem 1rem"><p class="clear_style"><span class="themeColor zt14">选择日期</span><img style="margin-left: 0.3rem" class="nav_item_btn fr" src="@/images/icon_arrow@3x.png"><date-picker v-if="selectedDate!=''" @selectData="selectDateAction()" :value="selectedDate"  ref="dataPicker" class="fr"></date-picker></p></div>
<!--            v-if="productItem.productStoreId == 'OnlineStore'"-->
            <div class="fl"  v-for="(productItem,index) in productList" :key="index">
              <div class="pl_info2"  v-if="productItem.addCartEnable == 'Y'" >
                <van-image @click="goDetail(productItem.productId)" class="pl_info2_img" fit="cover" :src="productItem.imgUrl"/>
                <p @click="goDetail(productItem.productId)" class="pl_info2_title">{{productItem.productName}}</p>
                <span @click="goDetail(productItem.productId)" class="pl_info2_price fl" >¥{{productItem.price}}</span>
                <span v-if="productItem.productStoreId != ''" @click="addCart(productItem.productId,productItem.productStoreId,productItem.productName,productItem)" class="fr pl_info2_addCart add_cart_btn">添加购物车</span>
              </div>
            </div>

            <div class="ovh" >
              <p class="tc zt12">此商品当前暂不可购买</p>
            </div>
            <refresh class="fl full_w" style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: productList.length,show:show}'></refresh>
          </div>
        </van-pull-refresh>
      </div>

      <!--结算-->
      <div class="balance_view">
        <van-button class="fr" ref="jiesuanBtn" color="#AF97E7" :disabled="addIndex<=0" style="width: 7rem;height: 3rem" :loading="nextStepLoading" type="primary" loading-text="跳转中" @click="goCart()" >下一步</van-button>
        <p class="fl zt12 black" style="margin-left: 0.5rem;color: #666666;line-height: 2rem">已添加:<span class="zt12 total_price_view" style="color: #666666">{{addIndex}}个</span></p>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { severUrl,storeName,prodCatalogId ,} from '@/router/Constant'
  import { addProductToCart,login,getAddOnItems,getServerTime,cartIsAllCheck,clearCart } from '@/router/api';
  import { setStore,getStore,removeStore,getCookie,setCookie } from '@/utils/mUtil';
  import { Image,Button } from 'vant';
  import {Overlay,PullRefresh,Toast } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';
  import datePicker from '@/components/page/common/Datepicker1.vue';

  export default {
    name: "collectBills",
    data() {
      return {
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        productList:[],
        isLoading:false,
        showLoading:true,
        nextStepLoading:false,
        emptyCart:false,
        show:false,
        productPromoId:this.$route.query.productPromoId,
        productPromoRuleId:this.$route.query.productPromoRuleId,
        // refreshMore
        allLoaded: false,
        addIndex:0,
        selectedDate:'',
        showEmptyView:false,
        showDateView:false,
        nowDateInfo:'',
        viewIndex:0,
        viewSize:20,

        show: false,
        allLoaded: false,
        token:getStore('externalLoginKey'),
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      footerView,
      loading,
      refresh,
      datePicker,
    },
    methods:{
      async initData() {
        console.log('this.selectedDate=============' + this.selectedDate)
        this.clearCartAction();
        this.getSeverTime();
      },
      selectDateAction(){
        console.log(this.$refs.dataPicker.dateValue)
        console.log(new Date(this.$refs.dataPicker.dateValue).getTime())
        console.log(this.selectedDate)
        console.log(new Date(this.selectedDate).getTime())
        this.selectedDate = this.$refs.dataPicker.dateValue
        this.getAddOnItems()
      },
      clearCartAction(){
        clearCart({productStoreId:'Tickets'})
          .then(res => {
            console.log("clearCart");
            console.log(res);
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {

            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      getAddOnItems() {
        var param = {externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId,prodCatalogId:prodCatalogId,viewIndex:this.viewIndex,viewSize:this.viewSize,productPromoRuleId:this.productPromoRuleId,productPromoId:this.productPromoId,selectedDate:this.selectedDate}
        console.log(param)
        getAddOnItems({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId,prodCatalogId:prodCatalogId,viewIndex:this.viewIndex,viewSize:this.viewSize,productPromoRuleId:this.productPromoRuleId,productPromoId:this.productPromoId,selectedDate:this.selectedDate})
          .then(res => {
            console.log("getAddOnItems")
            console.log(res)
            setTimeout(() => {
              this.showLoading = false
            }, 1000);
            this.productList = res.productList
            this.viewIndex = res.viewIndex
            this.viewSize = res.viewSize
            // debugger
            if(res.productList.length>1){

              //不跳转，当前就是列表，点哪个进哪个
              console.log('res.productList[0].productStoreId'+res.productList[0].productStoreId)
              if (res.productList[0].productStoreId == 'OnlineStore' || res.productList[0].productStoreId == '') {
                this.showDateView = true
              }
            }else if(res.productList.length==1){
              if(res.isOne == 'Y' && res.productList[0].productStoreId == 'OnlineStore'){
                //跳转至购物车
                this.showDateView = true
                if (!getStore('giveAway')){
                  // this.addProductCart(this.productList[0].productId,this.productList[0].productStoreId,this.productList[0].prodCatalogId)
                  // this.$router.push({name:'goodsDetail',query:{goodsId:this.productList[0].productId,fromUrl:"giveAway"}})
                } else {
                  removeStore('giveAway')
                }
              }else if(res.isOne == 'Y' && res.productList[0].productStoreId == 'Tickets'){
                if (res.productList[0].productName == '当日成人票'||res.productList[0].productName == '当日优待票'||res.productList[0].productName == '当日儿童票') {
                    this.showDateView = true
                  // 当日票不操作,后台判断是否可售
                  if (res.productList[0].addCartEnable == 'Y') {
                    this.addCart(res.productList[0].productId,res.productList[0].productStoreId,res.productList[0].productName)
                  } else {
                    // 不可操作，当页无产品
                    this.showEmptyView = false
                    this.emptyCart = true
                  }
                } else {
                  // 其他票型选择日期，并且从明日开始选择
                }
              } else if(res.isOne == 'Y' && res.productList[0].productStoreId.indexOf('Hotel') != -1){
                this.showDateView = false
                if (res.productList[0].addCartEnable == 'Y') {
                  this.addCart(res.productList[0].productId,res.productList[0].productStoreId,res.productList[0].productName,res.productList[0])
                }
              }
            } else {
              // 不可操作，当页无产品
              this.showEmptyView = false
            }

            setTimeout(() => {
              this.showLoading = false;
            }, 1000);
            if (res.productList.length == 0) {
              Toast('无促销商品或已下架')
              // this.$router.back(-1)
            }
          })
          .catch(err => {
            console.log(err);
            this.showLoading = false
          });
      },


      //添加购物车方法
      addProductCart:function(productId,productStoreId1,prodCatalogId1){
        let paramList = {
          externalLoginKey: this.token,
          productId: productId,
          productStoreId: productStoreId1,
          quantity:1,
          prodCatalogId:prodCatalogId1,
        }
        addProductToCart(paramList).then(res => {
          console.log(res)
          console.log('addProductToCart')
          // debugger
          if(res._ERROR_MESSAGE_==undefined){
            Toast({message:'添加成功'})
            this.$router.push({name:'cart',query:{fromUrl:"giveAway"}})
          }else{
            Toast({message:res._ERROR_MESSAGE_})
          }

        }).catch(err =>{
          console.log(err)
        })
      },

      getSeverTime () {
        getServerTime({})
          .then(res => {
            console.log("getServerTime")
            console.log(res)
            if (res.ServerTime) {
              var nowDate = new Date(res.ServerTime + 60*60*24*1000)
              this.nowDateInfo = res.ServerTime
              this.selectedDate = this.dateFormat("yyyy-MM-dd", nowDate)
            } else {
              this.selectedDate = this.getDefaultDate();
            }
            this.getAddOnItems();
          })
          .catch(err => {
            console.log(err);
            this.selectedDate = this.getDefaultDate();
            this.getAddOnItems();
          });
      },
      getDefaultDate(){
        var date = new Date(new Date().getTime() + 60*60*24*1000);
        this.nowDateInfo = new Date().getTime()
        console.log(date);
        return this.dateFormat("yyyy-MM-dd", date)
      },
      addCart(productId,productStoreId,productName,productItem) {

        // 当等于零售店铺的时候
        if(productStoreId == "OnlineStore") {
          addProductToCart({externalLoginKey:getStore('externalLoginKey'),quantity:1,productId:productId,productStoreId:productStoreId,prodCatalogId:this.prodCatalogId})
            .then(res => {
              console.log(res)
              if (res._ERROR_MESSAGE_) {
                Toast(res._ERROR_MESSAGE_);
              } else {
                this.addIndex ++
                Toast(res._EVENT_MESSAGE_);
              }
            })
            .catch(err => {
              console.log(err);
            });
          // 跳转到店铺的确认订单
        } else if (productStoreId == "Tickets") {
          var dateInfo = this.selectedDate
          if (productName == '当日成人票'||productName == '当日优待票'||productName == '当日儿童票') {
            dateInfo = this.dateFormat("yyyy-MM-dd", new Date(this.nowDateInfo))
          } else {
            dateInfo = this.selectedDate
          }
          console.log('dateInfo============' + dateInfo)
          var params = {externalLoginKey:getStore('externalLoginKey'),quantity:1,productId:productId,productStoreId:productStoreId,prodCatalogId:this.prodCatalogId,cartDate:dateInfo}
          console.log(params)
          addProductToCart({externalLoginKey:getStore('externalLoginKey'),quantity:1,productId:productId,productStoreId:productStoreId,prodCatalogId:this.prodCatalogId,cartDate:dateInfo})
            .then(res => {
              console.log(res)
              if (res._ERROR_MESSAGE_) {
                Toast(res._ERROR_MESSAGE_);
              } else {
                this.addIndex ++
                Toast(res._EVENT_MESSAGE_);
                if (this.addIndex == this.productList.length) {
                  this.goCart();
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else if (productStoreId.indexOf('Hotel') != -1) {
            console.log("addProductToCart")
            console.log('this.selectedDate=======' + this.selectedDate)
            var dateInfo = this.selectedDate
            let param = {
              externalLoginKey:getStore('externalLoginKey'),
              quantity:1,
              reservStart:dateInfo,
              reservLength:1,
              reservPersons:1, //人数
              productId:productId,
              productStoreId:productStoreId,
              prodCatalogId:productItem.prodCatalogId,
            }
            console.log(param)
            addProductToCart({externalLoginKey:getStore('externalLoginKey'), quantity:1, reservStart:dateInfo, reservLength:1, reservPersons:1,productId:productId,productStoreId:productStoreId,prodCatalogId:productItem.prodCatalogId,})
              .then(res => {
                console.log(res)
                if (res._ERROR_MESSAGE_) {
                  Toast(res._ERROR_MESSAGE_);
                } else {
                  this.addIndex ++
                  Toast('添加购物车成功');
                  // this.$router.replace({name:'hotelComfirm',query:{productStoreId:productItem.productStoreId,prodCatalogId:productItem.prodCatalogId,storeName:productItem.productStoreName}})
                  setStore('hotelProductStoreId',productItem.productStoreId)
                  setStore('hotelProdCatalogId',productItem.prodCatalogId)
                  setStore('hotelStoreName',productItem.productStoreName)
                  setStore('onRefresh',"onRefresh")
                  window.location.href = severUrl + '/hotel/#/hotelComfirm?productStoreId=' + productItem.productStoreId + "&" + 'prodCatalogId=' + productItem.prodCatalogId + "&" + 'storeName=' + productItem.productStoreName + "&" + "externalLoginKey=" + getStore('externalLoginKey')
                }
              })
              .catch(err => {
                console.log(err);
              });
        }
      },

      goCart(){
        this.nextStepLoading = true;
        setTimeout(() => {
          if (this.productList[0].productStoreId =='OnlineStore') {
            this.$router.push({name:'cart',params:{}})
          } else if (this.productList[0].productStoreId =='Tickets') {
            console.log(this.productList[0])
            setStore('onRefresh',"onRefresh")
            if (this.productList[0].productName.indexOf('当日') != -1) {
              setStore('selectedDate',this.dateFormat("yyyy-MM-dd", new Date(this.nowDateInfo)))

              window.location.href = severUrl + "/ticket/#/ticketComfirm?externalLoginKey=" + getStore('externalLoginKey')
            } else {
              setStore('selectedDate',this.selectedDate)
              window.location.href = severUrl + "/ticket/#/ticketComfirm?externalLoginKey=" + getStore('externalLoginKey')
            }
          }
        }, 1000);
      },

      goDetail(goodsId){
        console.log(item)
        //如果是零售店铺的商品就跳转详情 如果不是就不要进入详情
        if(item.storeName == 'OnlieStore'){
          this.$router.push({name:'goodsDetail',query:{goodsId:goodsId}})
        }

      },

      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          console.log('this.viewIndex' + this.viewIndex)
          getAddOnItems({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId,prodCatalogId:prodCatalogId,viewIndex:this.viewIndex,viewSize:this.viewSize,productPromoRuleId:this.productPromoRuleId,productPromoId:this.productPromoId})
            .then(res => {
              console.log("getAddOnItems-loadMore")
              console.log(res)
              this.show = true
              if (res.productList.length < this.viewSize) {
                this.allLoaded = true
              } else {
                this.allLoaded = false
              }
              var oldProductList = this.productList
              var newProductList = oldProductList.concat(res.productList)
              this.productList = newProductList
              this.viewIndex = res.viewIndex;
              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
            })
            .catch(err => {
              console.log(err);
            });
        }
      },
      dateFormat (fmt, date) {
        let ret;
        let opt = {
          "y+": date.getFullYear().toString(),        // 年
          "M+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },
      resetScorllView() {
        this.$router.afterEach((to,from, next) => {
          window.scrollTo(0,0)
        })
      },
      //下拉刷新
      onRefresh() {
        console.log('onRefreshUrl======' + window.location.href)
        setStore('onRefresh',"onRefresh")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },
    },
    mounted() {
      this.initData();
      this.resetScorllView();
    }

  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 21.05rem; margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
    border: 1px solid #EB84AB;color: #EB84AB;padding: 0.1rem 0.5rem;border-radius: 0.7rem;position: relative;margin-top: -0.3rem;
  }

  .pl_info2 {
    height: 5rem;padding: 0.8rem 1rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info2_img {
    width: 5rem;height: 5rem;float: left;margin-right: 0.5rem;line-height: 6.875rem;
  }

  .pl_info2_title {
    float: left;width: 15rem;height:3rem;margin: 0;font-size: 0.875rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info2_price {
    font-size: 1rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info2_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .balance_view {
    height: 3rem;width: 100%;position: fixed;bottom: 0;background-color: white;box-shadow: 0px -2px 10px #F0F0F0;
  }

  .all_check_btn {
    line-height: 3rem;width: 5rem;height: 3rem;padding-left: 0.5rem
  }

  .total_price_view {
    margin-left: 0.5rem;color: #EB84AB;
  }

  .reduce_disabled_btn {
    color: #eaeaea;
  }

  .add_cart_btn {
    padding: 0.2rem 0.7rem;
    background-color: #EB84AB;
    color: white;
    border-radius: 0.3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/cart/giveawayList.vue